// MissionSection.js
// This component describes the foundation's mission.

import missionContent from "../../content/mission.json"; // ✅ Load mission data from JSON

export default function MissionSection() {
  return (
    <section className="py-16 px-6 bg-orange-200">
      <div className="container mx-auto max-w-4xl text-center">
        
        {/* Title with Underline */}
        <h2 className="text-3xl font-bold text-gray-800 relative inline-block">
          {missionContent.title}
        {/*   <span className="block w-16 h-1 bg-orange-500 mx-auto mt-2"></span> */}
        </h2>

        {/* Mission Description */}
        <p className="text-lg text-gray-700 leading-relaxed mt-6 text-justify">
          {missionContent.description}
        </p>
      </div>
    </section>
  );
}